import { render, staticRenderFns } from "./Otro.vue?vue&type=template&id=6081553e&"
import script from "./Otro.vue?vue&type=script&lang=js&"
export * from "./Otro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports